import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  Input,
  ViewChild,
  ViewContainerRef,
  Type,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppRanking } from '../models/mobileAppRanking';
import { GroupType } from '../types/group-type';
import { MainFilterItem } from '../models/mainFilterItem';
import { GridHeader } from '../models/gridHeader';
import { User } from '../../../../models/User';

@Component({
  selector: 'app-ranking-widget-container',
  template: `
    <ng-container *ngIf="header.lockIfFreemium && isFreemium">
      <div class="circle-lock-cont"><i class="fa fa-lock"></i></div>
    </ng-container>
    <template #container></template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WidgetContainerComponent implements OnInit, AfterViewInit {
  @Input() data: MobileAppRanking;
  @Input() widgetComponent: Type<DataWidgetComponent>;
  @Input() selectedGroup: GroupType;
  @Input() mainFilterItems: MainFilterItem[];
  @Input() key: string;
  @Input() header: GridHeader;
  @Input() reportId: string;
  @ViewChild('container', { read: ViewContainerRef })
  container: ViewContainerRef;

  isFreemium: boolean = false;

  constructor(
    private _componentFactoryResolver: ComponentFactoryResolver,
    private _changeDetector: ChangeDetectorRef,
    private _userService: User,
    private user: User
  ) {}

  ngOnInit() {
    this.isFreemium = this.user.isFreemium();
  }

  ngAfterViewInit(): void {
    if (this.header.lockIfFreemium && this.isFreemium) {
      // Do Nothing, it'll display lock in template
    } else {
      this.container.clear();
      const componentFactory =
        this._componentFactoryResolver.resolveComponentFactory<DataWidgetComponent>(
          this.widgetComponent
        );
      const componentRef = this.container.createComponent(componentFactory);
      const instance = componentRef.instance;
      instance.data = this.data;
      instance.selectedGroup = this.selectedGroup;
      instance.mainFilterItems = this.mainFilterItems;
      instance.key = this.key;
      instance.header = this.header;
      instance.reportId = this.reportId;
      instance.userService = this._userService;
      this._changeDetector.detectChanges();
    }
  }
}
